/// Backend configuration, matching the two native apps.
///
/// None of it is secret: the Cognito app client is public and uses PKCE
/// precisely because a browser cannot keep a secret. Vite inlines these at
/// build time, so a deploy can point at a different stack without a code
/// change.
const env = import.meta.env;

export const config = {
  apiBaseURL: env.VITE_API_BASE_URL ?? 'https://api.donttestinprod.co.uk',
  authDomain: env.VITE_AUTH_DOMAIN ?? 'https://login.donttestinprod.co.uk',
  clientID: env.VITE_AUTH_CLIENT_ID ?? '5ga3nkqotp1s400id5uef89fq9',
  // Must be registered on the app client. Derived from wherever the app is
  // actually served, so localhost and production both work from one build.
  redirectURI: `${window.location.origin}/callback`,
  // Public by necessity: a static site cannot hide it, and Google's answer is
  // an HTTP-referrer restriction on the key rather than secrecy. Empty when
  // unset, which the route pages report rather than failing obscurely.
  mapsKey: env.VITE_GOOGLE_MAPS_KEY ?? '',
} as const;
